/**
 * Гарантирует уникальные ID тарифов, добавляя суффиксы к дубликатам.
 * @param {Array} tariffs
 * @returns {Array}
 */
export function ensureUniqueTariffIds(tariffs = []) {
    const seen = new Map();

    return tariffs.map((tariff, index) => {
        const baseId =
            tariff.id ||
            `${tariff.providerId || 'provider'}-${tariff.link || 'link'}-${tariff.price || 0}-${index}`;

        const duplicatedCount = seen.get(baseId) || 0;
        seen.set(baseId, duplicatedCount + 1);

        const uniqueId = duplicatedCount === 0 ? baseId : `${baseId}-${duplicatedCount}`;

        if (tariff.id === uniqueId) {
            return tariff;
        }

        return {
            ...tariff,
            id: uniqueId
        };
    });
}


